import { useEffect, useRef, useState } from 'react';

export function useInViewport<T extends HTMLElement>(rootMargin = '200px') {
  const ref = useRef<T | null>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!ref.current || !('IntersectionObserver' in window)) return () => {};
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setVisible(true);
          observer.disconnect(); // stop observing once visible
        }
      },
      { rootMargin },
    );
    observer.observe(ref.current);
    return () => {
      observer.disconnect();
    };
  }, [rootMargin]);

  return { ref, visible };
}
